import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import Head from './Head'

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"
import Select from "../../../../helpers/ui/CustomSelect"
import TableActiveComponent from './Components/TablePrimaryComponent'

const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")
    const activeRef = useRef();
    const inactiveRef = useRef();
    const [filter, setFilter] = useState()

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "")
        : (employeeSeleted != null ? employeeSeleted : "")

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()
    const [status, setStatus] = useState(null)
    const statusItems = [
        { value: '', label: "Semua" },
        { value: 1, label: "Sudah Mengisi" },
        { value: 0, label: "Belum Mengisi" },
    ]
    const handleButtonSearch = () => {
        let params = {
            status: status
        }

        setFilter(params)
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }
    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Head uuid={props.uuid} />
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                    {/* {
                                    (accessRole('create')) ?
                                        <Link to="?create">
                                            <Button color="primary">Tambah Pengajuan WFH</Button>
                                        </Link>
                                    : null
                                } */}

                                </div>

                                <CardTitle>Monitoring Laporan WFH</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Daftar Pegawai
                                </CardSubtitle> */}

                                <hr />
                                <Row className="mb-1">
                                    <label className="col-md-2">
                                        Status Laporan
                                    </label>
                                    <Col md="3">
                                        <Select options={statusItems} isAvForm={false} isClearable={true} onChange={opt => setStatus(opt ? opt.value : null)} />
                                    </Col>
                                </Row>
                                {/*
                                <Row className="mb-1">
                                    <label className="col-md-3">
                                        Nama
                                    </label>
                                    <Col md="9">
                                        {
                                            peg_detail.employee_full_name
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <label className="col-md-3">
                                        Jabatan
                                    </label>
                                    <Col md="9">
                                        {
                                            peg_detail.employee_current_position_name
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <label className="col-md-3">
                                        Unit Kerja
                                    </label>
                                    <Col md="9">
                                        {
                                            peg_detail.employee_current_work_unit_name
                                        }
                                    </Col>
                                </Row>
                                <hr />*/}
                                <Row className="mb-1">
                                    <Col md="10">
                                        {/* {
                                        userdata?.is_atasan == 1 &&
                                                <Link to="?list_bawahan">
                                                    <Button color="primary">List Pengajuan WFH Bawahan</Button>
                                                </Link>
                                    } */}
                                        {/* <Button color="primary" className="ms-2" onClick={() => reloadActiveRef()}>Cari</Button> */}
                                        <Button
                                            color="primary"
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                    </Col>
                                </Row>
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} uuid={props.uuid} filter={filter} />
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView